import React from 'react'
import CoursePackage from '../Flows/Student/Dashboard/CoursePackage/CoursePackage'


function ProductPage() {
    return (
        <>
            <CoursePackage />
        </>
    )
}

export default ProductPage